// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7724":"a6884fb3","7795":"9d93842a","8985":"cd6d6cc2"}[chunkId] + ".chunk.css";
};